import React from 'react';
import { isMobile } from 'react-device-detect';

import Imagem from 'Component/Imagem';

import type { Props } from './index';

const Login = (props: Props): React.ReactElement =>
{
    return (
        <div className="d-flex bg-light h-100">
            <div className="h-100 bg-primary flex-grow-1 d-none d-sm-block">
                <Imagem src="fundo-login.jpg" className="w-100 h-100 object-fit-cover" />
            </div>
            <div className="h-100 bg-white d-flex justify-content-center align-items-center px-4 flex-column" style={{ width: !isMobile ? '500px' : '100%' }}>
                {props.children}
            </div>
        </div>
    )
}

export default Login;
